import React, {memo} from 'react'
import {useMessage} from '@assistant-ui/react'
import {getOmicsAssistantMessage} from './getOmicsAssistantMessage'
import {OmicsAssistantGroupedParts} from './omicsAssistantGroupedParts'
import {hasRealAssistantParts, OmicsAssistantThinking} from './omicsThinkingIndicator'

export interface OmicsAssistantMessagePartsProps {
  onRetryRecursionLimit?: (content: string) => void
  onContinueRecursionLimit?: () => void
}

export const OmicsAssistantMessageParts: React.FC<OmicsAssistantMessagePartsProps> = memo(
  ({onRetryRecursionLimit, onContinueRecursionLimit}) => {
    const message = useMessage((s) => getOmicsAssistantMessage(s))

    if (!message) {
      return null
    }

    return (
      <div className='omics-assistant-turn'>
        {message.streamAlert ? (
          <div
            role='alert'
            className={`ai-chat-stream-alert ai-chat-stream-alert--${message.streamAlert.kind}`}
          >
            <i className='fas fa-circle-exclamation' aria-hidden />
            <span>{message.streamAlert.message}</span>
          </div>
        ) : null}

        {Boolean(message.isStreamingTurn) && !hasRealAssistantParts(message) ? (
          <OmicsAssistantThinking />
        ) : (
          <OmicsAssistantGroupedParts />
        )}

        {message.type === 'bot' &&
        message.recursionLimitHit &&
        (onRetryRecursionLimit || onContinueRecursionLimit) ? (
          <div className='recursion-limit-actions'>
            {onRetryRecursionLimit && message.recursionLimitUserMessage ? (
              <button
                type='button'
                className='btn btn-sm btn-outline-primary recursion-limit-btn'
                onClick={() => onRetryRecursionLimit(message.recursionLimitUserMessage!)}
              >
                Retry
              </button>
            ) : null}
            {onContinueRecursionLimit ? (
              <button
                type='button'
                className='btn btn-sm btn-outline-secondary recursion-limit-btn'
                onClick={onContinueRecursionLimit}
              >
                Continue in new message
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    )
  },
)

OmicsAssistantMessageParts.displayName = 'OmicsAssistantMessageParts'
